<template>
  <section>
    <!-- 统计文字 -->
    <!--<el-row class="total">
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-question sicon c1"></i>
        <span class="tjContent">
          <div>访问人数</div>
          <div class="numText t1">{{cdata.total.visit_uv||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-success sicon c2"></i>
        <span class="tjContent">
          <div>新增访问</div>
          <div class="numText t2">{{cdata.total.visit_uv_new||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-news sicon c3"></i>
        <span class="tjContent">
          <div>打开次数</div>
          <div class="numText t3">{{cdata.total.session_cnt||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-tickets sicon c2"></i>
        <span class="tjContent">
          <div>新增授权</div>
          <div class="numText t2">{{cdata.total.auth_uv_new||'0'}}</div>
        </span>
      </el-card>
      <el-card class="box-card" shadow="hover">
        <i class="el-icon-tickets sicon c4"></i>
        <span class="tjContent">
          <div>单用户点击数</div>
          <div class="numText t4">{{cdata.total.click_per||'0'}}</div>
        </span>
      </el-card>
    </el-row>-->
    <el-row style="min-width:1200px;padding:15px;background:#fff">
      <el-col style="min-width:600px" :span="24">
        <el-row :gutter="10">
          <!--<el-button type="primary" plain @click="changeDate(1)"  id='yesterday'>昨天</el-button>
          <el-button type="primary" plain @click="changeDate(2)"  >前天</el-button>-->
          <!--<el-button type="primary" plain @click="changeDate(7)">最近7天</el-button>-->
          <!--<el-date-picker
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>-->
          
          <!--<el-date-picker
		      v-model="pdata.sdate"
		      type="datetime"
		      placeholder="选择日期时间"
	        format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
		      align="right"
		      @change="selectDate"
		      :picker-options="pickerOptions">
		    </el-date-picker>-->
          <!--<el-select v-model="chooseProduct.name" filterable placeholder="请输入小程序名称">
					    <el-option
					      v-for="item in IssAppList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id"
					      @click.native="changeProduct(item)"
					      default-first-option
					    ></el-option>
				 </el-select>-->
				 <div class="mainSelect" >
				 		  <el-select v-model="chooseProduct.name" filterable  placeholder="请输入/选择小程序名称" >
					    <el-option
					      v-for="item in IssAppList"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id"
					      @click.native="changeProduct(item)"
					     
					      default-first-option
					    ></el-option>
				 </el-select>
				 </div>
				
        </el-row>
      </el-col>
      <!--<el-col :span="10">
        <div style="float:right;min-width:150px">
          <el-row :gutter="10">


            <el-input
              style="width:170px"
              @clear="getList"
              @keyup.enter.native="getList"
              ref="input"
              class="search"
              v-model="pdata.kw"
              clearable
              placeholder="请输入小程序名称"
              :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
            ></el-input>
          </el-row>
        </div>
      </el-col>-->
    </el-row>

    
    <!-- 图表 -->
    <!--<el-row style="min-width:1200px;background:#fff">
      <div id="chart" style="width:100%; height:500px;"></div>
    </el-row>-->
    <!--列表-->
    <!--<el-table :data="cdata.list" style="width: 100%;min-width:1200px" stripe row-key="id">

       <el-table-column prop="issued_app_id" label="ID" align="left"></el-table-column>
     
      <el-table-column prop="app_name" label="发行游戏" align="left">

      </el-table-column>
      <el-table-column prop="jump_per" label="跳出率" align="left">
      		<template slot-scope="scope"><span v-if="scope.row.jump_per!=null">{{scope.row.jump_per||0}}%</span><span v-else>--</span> </template>
      </el-table-column>
      <el-table-column prop="day1" label="1日留存" align="left">
      	  <template slot-scope="scope"><span v-if="scope.row.day1!=null">{{scope.row.day1||0}}%</span><span v-else>--</span> </template>
      </el-table-column>
      <el-table-column prop="day2" label="2日留存" align="left">
      	<template slot-scope="scope"><span v-if="scope.row.day2!=null">{{scope.row.day2||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day3" label="3日留存" align="left">
      		<template slot-scope="scope"><span v-if="scope.row.day3!=null">{{scope.row.day3||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day4" label="4日留存" align="left">
      		<template slot-scope="scope"><span v-if="scope.row.day4!=null">{{scope.row.day4||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day5" label="5日留存" align="left">
      		<template slot-scope="scope"><span v-if="scope.row.day5!=null">{{scope.row.day5||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day6" label="6日留存" align="left">
      		<template slot-scope="scope"><span v-if="scope.row.day6!=null">{{scope.row.day6||0}}%</span> <span v-else>--</span></template>
      </el-table-column>
      <el-table-column prop="day7" label="7日留存" align="left">
      		<template slot-scope="scope"><span v-if="scope.row.day7!=null">{{scope.row.day7||0}}%</span><span v-else>--</span> </template>
      </el-table-column>
       
      
      <el-table-column prop="day7" label="" align="left">
	      <template slot-scope="scope">
	          <el-button
	            size="mini"
	            type="primary"
	            @click="$router.push({
	          name:'渠道数据分析列表',
	          params:{issued_app_id:scope.row.issued_app_id},
	          query:{sdate:pdata.sdate,edate:pdata.edate}
	        })"
	          >详情</el-button>
	      </template>
      </el-table-column>

    </el-table>-->

    <!--<el-pagination
      class="pagination"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :current-page.sync="pdata.page"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="pdata.perpage"
      background
      layout="sizes, prev, pager, next, jumper"
      :total="pdata.perpage*maxPage"
    ></el-pagination>-->

    <!--<el-dialog title="编辑创意组合" :visible.sync="editDialog">
      <el-form :model="group"></el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="editDialog = false">确 定</el-button>
      </div>
    </el-dialog>-->
  </section>
</template>

<script>
import { getCFXList, getDetailData ,  getIssuedAppList} from "../../api/api";
import echarts from "echarts";

export default {
  data() {
    return {
      chartColumn: null,
      showSelect:true,
      chooseProduct:{name:"",id:''},
      IssAppList:[],
      pdata: {
      	issued_app_id: "",
        page: 1,
        perpage: 20,
        source: "",
        kw: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
        // sdate: "2019-04-15",
        // edate: "2019-04-15",
      },
      tText: "请选择创意类型",
      plist: [],
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},
			chooseProduct:{name:"",id:''},
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      cdata: { total: {}, chat: {}, list: [], max_page: 1 }, //所有数据
      option: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["访问人数", "打开次数", "新用户数","新增授权","单个用户点击次数"]
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: "category",
          
          data: []
        },
        yAxis: {
          type: "value"
        },
        series: [
            // "访问人数", "打开次数", "新用户数","新增授权","单个用户点击次数"
          {name: "访问人数",type: "line",smooth: true,data: []},
          {name: "打开次数",type: "line",smooth: true,data: []},
          {name: "新用户数",type: "line",smooth: true,data: []},
          {name: "新增授权",type: "line",smooth: true,data: []},
          {name: "单个用户点击次数",type: "line",smooth: true,data: []},
        ],
        color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ]
      }
    };
  },
  watch: {

  },
  methods: {
  	changeProduct(res){
  	
  	 this.$cookie.setCookie("issued_app_id",res.id);
		 this.$route.params.issued_app_id=res.id;
	 	 this.pdata.issued_app_id=res.id;
	 	 this.$router.push({
	          name:'渠道数据分析列表',
	          query:{sdate:this.pdata.sdate,edate:this.pdata.edate}
	        })
	 	 
	 	 
	 },
		getIssAPPList(){
			var p="";
			getIssuedAppList(p, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.IssAppList = res.data;
	          this.IssAppList.forEach((v,i)=>{
	          	if(v.id==this.pdata.issued_app_id ){
	          		this.chooseProduct.name=v.name;
	          	}
	          })
	        }
	      });
		},
  	selectDate(e){
  		this.pdata.sdate = e;
      this.pdata.edate = e;
      this.getList();
      
  		
  	},
//	changeProduct(res){
//		 this.$route.params.issued_app_id=res.id;
//	 	 this.pdata.issued_app_id=res.id;
//	 	 this.getList();
//	 	 
//	 },
//	 getIssAPPList(){
//		var p="";
//		getIssuedAppList(p, this.$cookie.getCookie("login")).then(res => {
//      if (res.code == 200) {
//        this.IssAppList = res.data;
//        this.IssAppList.forEach((v,i)=>{
//        	if(v.id==this.pdata.issued_app_id ){
//        		this.chooseProduct.name=v.name;
//        	}
//        })
//      }
//    });
//	},
    getList() {
      var p = "";
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getCFXList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
            // "访问人数", "打开次数", "新用户数","新增授权","单个用户点击次数"
          this.cdata.list = res.data.list;
           this.maxPage = res.data.max_page;
          
//        this.option.xAxis.data = res.data.chart.date;
//        this.option.series[0].data = res.data.chart.visit_uv;
//        this.option.series[1].data = res.data.chart.session_cnt;
//        this.option.series[2].data = res.data.chart.visit_uv_new;
//        this.option.series[3].data = res.data.chart.auth_uv_new;
//        this.option.series[4].data = res.data.chart.click_per;
//        this.drawColumnChart();
        }
      });
    },
   
    drawColumnChart() {
      this.chartColumn = echarts.init(document.getElementById("chart"));
      this.chartColumn.setOption(this.option);
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeDate(s) {
    	 this.pdata.sdate=new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10);
    	 this.pdata.edate=new Date(new Date().getTime() - 3600 * 1000 * 24 * s).toISOString().slice(0, 10);
      
       this.getList();
    }
  },

  mounted() {
  	this.getIssAPPList();
  	this.pdata.issued_app_id= this.$cookie.getCookie("issued_app_id");
  	if(this.pdata.issued_app_id){
  	 this.showSelect=false;
  	 this.$route.params.issued_app_id=this.pdata.issued_app_id;
	 	 this.$router.push({
          name:'渠道数据分析列表',
          query:{sdate:this.pdata.sdate,edate:this.pdata.edate}
        })

  	}
  	else{
  		
  	}
  	
//	if(this.$route.query.sdate!=undefined){
//		this.pdata.sdate=this.$route.query.sdate;
//	}
//	if(this.$route.query.edate!=undefined){
//		  	this.pdata.edate=this.$route.query.edate;
//	}
//	this.dateVal = [this.pdata.sdate,this.pdata.edate];
////	this.getIssAPPList();
//  this.getList();
//  
//    document.getElementById('yesterday').focus();
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>

<style type="text/css" scoped="">
	.mainSelect{
		width: 200px;
		
		margin:400px auto;
	}
</style>






// WEBPACK FOOTER //
// channelData.vue?9aebeca6